import { getCountryCodeOverride } from '../components/debug-panel/debugOverrides';

/**
 * Extracts the country code from the locale set on the window object.
 *
 * For India (.in domain), always returns 'IN'.
 * Otherwise, uses the COUNTRY_CODE_FROM_LOCALE global variable if available.
 *
 * Copied from pricing-pages-ui/v2/utils/countryCodeUtils — do not import from there.
 *
 * @returns The uppercase country code (e.g., 'US', 'IN') or undefined if not available
 */
export const getCountryCodeFromLocale = (host = window.location.host) => {
  const override = getCountryCodeOverride();
  if (override) return override;
  const isInIndia = host.indexOf('hubspot.in') > -1;
  if (isInIndia) {
    return 'IN';
  }
  const raw = window.COUNTRY_CODE_FROM_LOCALE;
  const countryCodeFromLocale = typeof raw === 'string' ? raw : undefined;
  return countryCodeFromLocale === null || countryCodeFromLocale === void 0 ? void 0 : countryCodeFromLocale.toUpperCase();
};